let locales;

/** Get locales of the theme from the JSON static */
export const getLocales = async () => {
  if (locales) return locales;
  try {
    const response = await fetch(window.galaxyInfo.locales_theme);
    const data = await response.json();
    locales = data;
    return data;
  } catch (e) {
    console.error("[Locales: error fetching]", e);
  }
};
